/**
 * Popover with extended sanitizer (SVG: fill/stroke/opacity, etc. are allowed)
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
 */

export default (() => {
  // Merge Bootstrap default allowList with extra SVG tags/attributes
  const SVG_ALLOWLIST = {
    svg: [
      'class',
      'xmlns',
      'width',
      'height',
      'viewBox',
      'fill',
      'stroke',
      'role',
      'aria-hidden',
      'focusable',
    ],
    g: ['class', 'fill', 'stroke', 'opacity'],
    path: [
      'd',
      'fill',
      'fill-rule',
      'clip-rule',
      'opacity',
      'stroke',
      'stroke-width',
      'stroke-linecap',
      'stroke-linejoin',
      'stroke-miterlimit',
      'stroke-opacity',
    ],
    circle: ['cx', 'cy', 'r', 'fill', 'stroke', 'stroke-width', 'opacity'],
    ellipse: [
      'cx',
      'cy',
      'rx',
      'ry',
      'fill',
      'stroke',
      'stroke-width',
      'opacity',
    ],
    rect: [
      'x',
      'y',
      'width',
      'height',
      'rx',
      'ry',
      'fill',
      'stroke',
      'stroke-width',
      'opacity',
    ],
    line: [
      'x1',
      'x2',
      'y1',
      'y2',
      'stroke',
      'stroke-width',
      'opacity',
      'stroke-linecap',
      'stroke-linejoin',
    ],
    polyline: ['points', 'fill', 'stroke', 'stroke-width', 'opacity'],
    polygon: ['points', 'fill', 'stroke', 'stroke-width', 'opacity'],
    use: ['href', 'xlink:href'], // in case you use symbol sprites
  }

  // Start from Bootstrap defaults and extend them safely
  /* eslint-disable no-undef */
  const extendedAllowList = {
    ...bootstrap.Tooltip.Default.allowList,
    ...SVG_ALLOWLIST,
    '*': [
      ...(bootstrap.Tooltip.Default.allowList['*'] || []),
      'class',
      'role',
      'aria-label',
      'aria-hidden',
    ],
    // Note: we intentionally do NOT allow `style` to keep XSS surface small.
  }
  /* eslint-enable no-undef */

  // Initialize all popovers with HTML + extended sanitizer
  /* eslint-disable no-undef */
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    new bootstrap.Popover(el, {
      html: true,
      sanitize: true,
      allowList: extendedAllowList,
      container: '.hulk-scope', //Josh added this to fix the tooltip not being visible in the hulk-scope.
    })
  })
  /* eslint-enable no-undef */
})()
